import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SituationsSection } from './components/SituationsSection';
import { ProcessSection } from './components/ProcessSection';
import { PortfolioSection } from './components/PortfolioSection';
import { PillarsSection } from './components/PillarsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <ProcessSection data-id="element-4" />
      <PortfolioSection data-id="element-5" />
      <SituationsSection data-id="element-6" />
      <PillarsSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <FinalCTASection data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}